import * as React from 'react';
import * as classnames from 'classnames/bind';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {observer} from 'mobx-react';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {MDIcon} from '@mintdata-wsp/common/components/icon/MDIcon';

const styles = require('./LogoHeader.less');
const cx = classnames.bind(styles);

export interface LogoHeaderProps
{
    className?:string;
}

@observer
export class LogoHeader extends React.Component<LogoHeaderProps, any>
{
    _onLogoClicked()
    {
        controllers.navigation.toAppHome();
    }

    render()
    {
        let {className} = this.props;

        return (
            <Row className={cx('logoHeader', className)}>
                <a className={cx('logoLink')} onClick={this._onLogoClicked}>
                    <MDIcon className={cx('logoIcon')} name={MDIcons.logo.MintDataLogo2}/>
                    <MDIcon className={cx('logoText')} name={MDIcons.logo.MintDataLogo}/>
                </a>
            </Row>
        );
    }
}
